/* Derived view-model for the data route.
 * GENERATED from the original artifact's vals_data() by
 * tools/convert-logic.py; edits since generation are tracked in git. */
import { FOOTER_COLS, SOURCES, STATES } from '@/data/wft';

export function dataVals() {
  const src = SOURCES;
  const tierOf = (t: string) => src.filter((s) => s.tier === t);
  const mk = (label: string, tier: string, color: string, body: string) => {
    const items = tierOf(tier);
    return {
      label,
      color,
      count: String(items.length),
      body,
      cells: items.map((s) => ({ title: s.label })),
    };
  };

  return {
    footerCols: FOOTER_COLS,
    states: STATES,
    sources: src.map((s) => ({
      label: s.label,
      cadence: s.cadence,
      key: s.key,
      feeds: s.feeds,
      note: s.note,
      redist: s.redist,
      redistColor: s.redist === 'yes' ? 'var(--wft-ink-1)' : 'var(--wft-accent)',
    })),
    tiers: [
      mk(
        'Free · keyless',
        'free · keyless',
        'var(--wft-live)',
        'Nothing to sign up for. These are bound the moment the stack starts.'
      ),
      mk(
        'Free · key',
        'free · key',
        'var(--wft-delayed)',
        'A free signup unlocks Rates, Macro, Filings and parts of Cockpit.'
      ),
      mk(
        'Paid · optional',
        'paid · optional',
        'var(--wft-accent)',
        'Intraday coverage. Without them those panels are honestly empty.'
      ),
      mk(
        'Engine',
        'engine',
        'var(--wft-engine)',
        'GodEngine: TimesFM 2.5 forecasts and swarm scenario resolve.'
      ),
    ],
    envKeys: [
      { env: 'FRED_API_KEY', gives: 'Rates, Macro and parts of Cockpit. Instant signup.' },
      {
        env: 'SEC_CONTACT',
        gives: 'Filings. A contact string for the fair-use user agent, not a key.',
      },
      { env: 'POLYGON_API_KEY', gives: 'Intraday equity coverage in Markets.' },
      { env: 'FINNHUB_API_KEY', gives: 'Optional supplementary equity and filing data.' },
      { env: 'TWELVEDATA_API_KEY', gives: 'Optional intraday FX and equities.' },
    ],
  };
}

export type DataVals = ReturnType<typeof dataVals>;
